import * as React from "react"
import { type VTableSectionProps } from "@digits-shared/components/UI/VirtualizedTable/vTableTypes"
import { Th, Thead, ThSort, THSortArrow, Tr } from "@digits-shared/DesignSystem/Tables/tableStyles"
import stringHelper from "@digits-shared/helpers/stringHelper"
import { flexRender } from "@tanstack/react-table"

/*
  COMPONENTS
*/
export const VTableHeader = <TData extends object>({ ref, table }: VTableSectionProps<TData>) => {
  const headerGroups = table.getHeaderGroups()
  if (!headerGroups.length) return null

  return (
    <Thead ref={ref}>
      {headerGroups.map((headerGroup) => (
        <Tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => {
            const key = header.id
            const isSortable = header.column.getCanSort() && header.column.columnDef.enableSorting
            if (isSortable) {
              const sortDirection = header.column.getIsSorted()
              return (
                <Th key={key} data-header={key} onClick={header.column.getToggleSortingHandler()}>
                  <ThSort className={stringHelper.classNames(sortDirection && "sorted")}>
                    {flexRender(header.column.columnDef.header, header.getContext())}
                    <THSortArrow className={stringHelper.classNames(sortDirection)} />
                  </ThSort>
                </Th>
              )
            }

            return (
              <Th key={key} data-header={key} colSpan={header.colSpan}>
                {flexRender(header.column.columnDef.header, header.getContext())}
              </Th>
            )
          })}
        </Tr>
      ))}
    </Thead>
  )
}
